// import axios from 'axios';
import base from '@/__vue2stone/service/wasaapi/v1/__base';
//承攬商
import store from '@/store';

export default {
  async create(factoryId, data, type = 'factory') {
    const currentOrganization = store.state.app.organization;
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    if (
      type === 'organization' &&
      currentOrganization &&
      currentOrganization.id
    ) {
      _data.organization = currentOrganization.id;
    }
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'sos_request',
      data: _data,
    });
    return res;
  },
};
